export enum InvoiceType {
  PAYABLE = "payable",
  RECEIVABLE = "receivable",
}

export type InvoiceTypeString = `${InvoiceType}`;
